import { Agency, agencyBasic } from '@app/models';
import { gql } from 'apollo-angular';

export interface ActivityType {
  id: number;
  code: string;
  description: string;
  predefined: boolean;
  ttpId: number;
  agency: Agency;
}

export const activityTypeDetailed = gql`
  fragment activityTypeDetailed on ActivityType {
    id
    code
    description
    predefined
    ttpId
    agency {
      ...agencyBasic
    }
  }
  ${agencyBasic}
`;

export const activityTypeBasic = gql`
  fragment activityTypeBasic on ActivityType {
    id
    code
    description
    predefined
    ttpId
    agency {
      id
    }
  }
`;
